/**
 * Canonical app paths — use for NavLink, Navigate, and route definitions
 * so URLs stay consistent in one place.
 */
export const PATHS = {
    landing: '/',
    login: '/login',
    signup: '/signup',
    dashboard: '/dashboard',
    calendar: '/calendar',
    activityHub: '/activity-hub',
    quizzes: '/quizzes',
    pricing: '/pricing',
    settings: '/settings',
    integrationsCallback: '/integrations/callback',
};
